import BaseApi from "./base-api";

/**
 * Class for the GoodLeap API
 *
 * @extends BaseApi
 * @description This class is used to interact with the GoodLeap endpoint
 */
class GoodLeapApi extends BaseApi {
  constructor() {
    super("goodleap");

    this.methods = {
      GET_DISCLOSURES: "get_disclosures",
      GET_GOODLEAP_APPS: "get_goodleap_apps",
      GET_OFFERS: "get_offers",
      SUBMIT_LOAN_APPLICATION: "submit_loan_application",
      GOODLEAP_CHANGE_ORDER: "goodleap_change_order",
      GET_EXISTING_SAVINGS: "get_existing_savings",
    };
  }

  /**
   * Get a list of disclosures for a goodleap application
   */
  getDisclosures = async () => {
    const response = await this.request({
      method: this.methods.GET_DISCLOSURES,
    });

    if (response.success) {
      return response;
    }

    throw new Error("Could not get GoodLeap disclosures");
  };

  /**
   * Get a list of disclosures for a goodleap application
   */
  getApplications = async () => {
    const response = await this.request({
      method: this.methods.GET_GOODLEAP_APPS,
      options: {
        override: {
          resource: "proposal-tool",
        },
      },
    });

    if (response.success) {
      return response;
    }

    throw new Error("Could not get GoodLeap disclosures");
  };

  getOffers = async () => {
    const response = await this.request({
      method: this.methods.GET_OFFERS,
    });

    if (response.success) {
      return response;
    }

    throw new Error("Could not get GoodLeap offers");
  };

  submitLoanApplication = async (data) => {
    const response = await this.request({
      method: this.methods.SUBMIT_LOAN_APPLICATION,
      ...data,
    });

    if (response.success) {
      return response;
    }

    throw new Error("Could not submit GoodLeap loan application");
  };

  /**
   * Submit a GoodLeap change order
   *
   * @param {Object} data
   * @returns {Promise<Object>} GoodLeap change order
   */
  submitChangeOrder = async (data) => {
    const response = await this.request({
      method: this.methods.GOODLEAP_CHANGE_ORDER,
      ...data,
    });

    if (response.success) {
      return response;
    }

    throw new Error("Could not submit GoodLeap change order");
  };
  
    getExistingSavings = async ( payload ) => {
      const response = await this.request({
        method: this.methods.GET_EXISTING_SAVINGS,
        ...payload,
      });
  
      if (response) {
        return response;
      }
  
      throw new Error(this.status, this.statusText, this.url);
    };
}

export default new GoodLeapApi();
